import client from "./client";

const save = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
};

// Official statements as PDF (company logo + Arabic RTL) or Excel.
export const exportReport = async (report, format, params, lang) => {
  const res = await client.get("/accounting/reports/export", {
    params: { report, format, lang, ...params },
    responseType: "blob",
  });
  save(res.data, `${report}-${params?.date_to || "all"}.${format}`);
  return true;
};

// Stored receipts are private: fetch them with the session token, then show the blob.
export const fetchFileBlob = async (url) => {
  const path = String(url).replace(/^\/api\/files\//, "");
  const res = await client.get(`/files/${path}`, { responseType: "blob" });
  return URL.createObjectURL(res.data);
};

export const payrollPostStatus = async (month) => (await client.get(`/accounting/payroll/${month}`)).data;export const accruePayroll = async (month) => (await client.post(`/accounting/payroll/${month}/accrue`)).data;
export const payPayroll = async (month, cashbox_id) =>
  (await client.post(`/accounting/payroll/${month}/pay`, { cashbox_id })).data;

export const sendMonthlyPack = async (month) =>
  (await client.post("/accounting/reports/monthly-pack", null, { params: { month } })).data;
export const packHistory = async () => (await client.get("/accounting/reports/monthly-pack")).data;
